const SAUDI_DEFAULT_CENTER = { lat: 23.8859, lng: 45.0792 };

const REGION_CENTERS = {
  makkah: { lat: 21.3891, lng: 39.8579 },
  riyadh: { lat: 24.7136, lng: 46.6753 },
  eastern: { lat: 26.4207, lng: 50.0888 },
};

const SUB_AREA_CENTERS = {
  "makkah-city": { lat: 21.4225, lng: 39.8262 },
  jeddah: { lat: 21.5433, lng: 39.1728 },
  taif: { lat: 21.2703, lng: 40.4158 },
  qunfudhah: { lat: 19.1269, lng: 41.0789 },
  lith: { lat: 20.1397, lng: 40.2666 },
};

const toNumberInRange = (value, min, max) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === "string" && !value.trim()) {
    return null;
  }

  const parsed = typeof value === "string" ? Number(value.trim()) : Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  if (parsed < min || parsed > max) {
    return null;
  }
  return parsed;
};

const buildCoordinatePair = (latValue, lngValue) => {
  const lat = toNumberInRange(latValue, -90, 90);
  const lng = toNumberInRange(lngValue, -180, 180);
  if (lat === null || lng === null) {
    return null;
  }
  return { lat, lng };
};

export const extractPropertyCoordinates = (property) => {
  if (!property || typeof property !== "object") {
    return null;
  }

  const candidates = [
    buildCoordinatePair(property.latitude, property.longitude),
    buildCoordinatePair(property.location_coords?.lat, property.location_coords?.lng),
    buildCoordinatePair(property.coordinates?.lat, property.coordinates?.lng),
    buildCoordinatePair(property.location?.lat, property.location?.lng),
    Array.isArray(property.location?.coordinates)
      ? buildCoordinatePair(property.location.coordinates[1], property.location.coordinates[0])
      : null,
  ];

  return candidates.find(Boolean) || null;
};

export const getFallbackCenter = (regionCode, subAreaCode) => {
  const subAreaKey = (subAreaCode || "").toLowerCase();
  const regionKey = (regionCode || "").toLowerCase();

  if (SUB_AREA_CENTERS[subAreaKey]) {
    return SUB_AREA_CENTERS[subAreaKey];
  }
  if (REGION_CENTERS[regionKey]) {
    return REGION_CENTERS[regionKey];
  }
  return SAUDI_DEFAULT_CENTER;
};

export const resolvePropertyMapCoordinates = (property) => {
  const exact = extractPropertyCoordinates(property);
  if (exact) {
    return { ...exact, isFallback: false };
  }

  const fallback = getFallbackCenter(property?.region_code, property?.sub_area_code);
  return { ...fallback, isFallback: true };
};

export const buildOpenStreetMapEmbedUrl = (lat, lng, zoom = 13) => {
  const clampedLat = toNumberInRange(lat, -90, 90);
  const clampedLng = toNumberInRange(lng, -180, 180);
  if (clampedLat === null || clampedLng === null) {
    const defaultCenter = SAUDI_DEFAULT_CENTER;
    return buildOpenStreetMapEmbedUrl(defaultCenter.lat, defaultCenter.lng, 6);
  }

  const span = zoom >= 12 ? 0.04 : 0.12;
  const left = clampedLng - span;
  const right = clampedLng + span;
  const top = clampedLat + span;
  const bottom = clampedLat - span;

  return `https://www.openstreetmap.org/export/embed.html?bbox=${left}%2C${bottom}%2C${right}%2C${top}&layer=mapnik&marker=${clampedLat}%2C${clampedLng}`;
};

export const formatCoordinateInput = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return "";
  }
  return parsed.toFixed(6);
};
